import Reviews from '@carvana/seo-reviews';
import isEmpty from 'ramda/src/isEmpty';
import { useContext } from 'react';
import styled from 'styled-components';
import { formatKeyWordAndLocation } from '@/srp/SEO/utils';
import { useTrackEvent } from '~/context/srp/SearchAnalyticsContext';
import SEOContext from '~/context/srp/SEOContext';
import type { SeoReviews } from '~/contracts/common/Seo';
import type { VanityUrlWithPath } from '~/contracts/srp';

const Wrapper = styled.div`
  h2 {
    text-transform: capitalize;
  }
`;

function constructSeoData(vanityUrl: VanityUrlWithPath | undefined) {
  return vanityUrl
    ? {
        flags: {
          hasCvnaid: false,
          isAllModels: false,
          isMultiMake: false,
          isNoMake: false,
          isSingleModel: false
        },
        seoH1: formatKeyWordAndLocation(vanityUrl)
      }
    : undefined;
}

function translateReviews(reviews?: SeoReviews) {
  return {
    reviews: reviews?.reviews ?? [],
    overallAverage: reviews?.summary?.review_average_rating ?? 0,
    overallCount: reviews?.summary?.review_count_total ?? 0,
    highestRating: (reviews?.summary?.review_highest_rating ?? '').toString(),
    lowestRating: (reviews?.summary?.review_lowest_rating ?? '').toString()
  };
}

type OwnProps = {
  contentReviews?: SeoReviews;
};

export default function ContentReviews({ contentReviews }: OwnProps) {
  const trackEvent = useTrackEvent();
  const { seoData: seoDataV1, vanityUrl } = useContext(SEOContext);
  const {
    overallAverage,
    overallCount,
    highestRating,
    lowestRating,
    reviews = []
  } = translateReviews(contentReviews);

  const seoData = constructSeoData(vanityUrl) ?? seoDataV1;

  const hasCvnaid = seoData?.flags?.hasCvnaid || false;

  return isEmpty(reviews) ? null : (
    <Wrapper>
      <Reviews
        showStructuredData
        contentReviews={reviews}
        overallCount={overallCount}
        overallAverage={overallAverage}
        seoData={seoData}
        highestRating={highestRating}
        lowestRating={lowestRating}
        trackEvent={trackEvent}
        hasCvnaid={hasCvnaid}
      />
    </Wrapper>
  );
}
